<template>
<div class="comisiones">
  <div class="comisiones__option">
    <div class="comisiones__title">
      <span class="priority">*</span>
      Remuneración Máxima Asegurable (RMA)
    </div>
    <input type="text" class="comisiones__input">
  </div>
  <div class="comisiones__option">
    <div class="comisiones__title">
      <span class="priority">*</span>
      Prima de Seguros (%)
    </div>
    <input type="text" class="comisiones__input">
  </div>
  <div class="comisiones__option">
    <div class="comisiones__title">
      <span class="priority">*</span>
      Fondo de Pensiones (%)
    </div>
    <input type="text" class="comisiones__input">
  </div>

  <div class="comisiones__afps">
    <div class="tipos-c">
      <div class="tipo-c__empty"></div>
      <div class="tipo-c__flujo">FLUJO<br>(%)</div>
      <div class="tipo-c__mx-flujo">MIXTA FLUJO<br>(%)</div>
      <div class="tipo-c__mx-saldo">MIXTA SALDO<br>(%)</div>
    </div>

    <div class="habitat">
      <div class="habitat__title">HABITAT</div>
      <div class="habitat__input">
        <input type="text">
      </div>
      <div class="habitat__input">
        <input type="text">
      </div>
      <div class="habitat__input">
        <input type="text">
      </div>
    </div>

    <div class="integra">
      <div class="integra__title">INTEGRA</div>
      <div class="integra__input">
        <input type="text">
      </div>
      <div class="integra__input">
        <input type="text">
      </div>
      <div class="integra__input">
        <input type="text">
      </div>
    </div>

  <div class="prima">
    <div class="prima__title">PRIMA</div>
    <div class="prima__input">
      <input type="text">
    </div>
    <div class="prima__input">
      <input type="text">
    </div>
    <div class="prima__input">
      <input type="text">
    </div>
  </div>

  <div class="profuturo">
    <div class="profuturo__title">PROFUTURO</div>
    <div class="profuturo__input">
      <input type="text">
    </div>
    <div class="profuturo__input">
      <input type="text">
    </div>
    <div class="profuturo__input">
      <input type="text">
    </div>
  </div>

  </div>

  
</div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS
.priority{
  color: $b-orange;
}

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

.comisiones{
  padding: 2rem 0;
  &__option{
    margin-bottom: 1.5rem;
    @include mq($sm){
      width: 30rem
    }
  }
  &__title{
    color: $b-blue-dark;
    font-size: 1.2rem;
  }
  &__input{
    height: 3rem;
    display: block;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #D7DAE2;
    box-shadow: 0px 2px 3px rgba(#000,0.05);
    padding-left: 1rem;
    margin-top: .5rem;
  }
  &__afps{
    width: 100%;
    @include mq($sm){
      width: 30rem;
    }
  }
}

.tipos-c{
  margin-top: 3rem;
  height: 3rem;
  width: 100%;
  display: flex;
  color: $b-blue-dark;
  font-weight: 600;
  &>*{
    width: 25%;
    text-align: center;
    font-size: .9rem;
    line-height: 1rem;
  }
}

.habitat,.integra,.prima,.profuturo{
  margin-top: 0rem;
  height: 3rem;
  width: 100%;
  display: flex;
  color: $b-blue-dark;
  font-weight: 600;
  &>*{
    width: 25%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .9rem;
    line-height: 1rem;
    input{
      display: block;
      width: 90%;
      height: 2rem;
      border-radius: 3px;
      border: 1px solid #d7dae2;
      box-shadow: 0px 2px 3px rgba(#000,0.05);
      text-align: right;
      padding-right: 1rem;
    }
  }
  &__title{
    justify-content: flex-start;
  }
}
</style>
